<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1>{{ exchangeRate.id ? 'Edit' : 'Add' }} Exchange Rate</h1>
    </div>
    <button
      class="close-button"
      mat-dialog-close>
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content aria-label="Add exchange rate modal">
  <div class="w-full">
    <form [formGroup]="modalForm">
      <div class="flex flex-row gap-8">
        <scope-ui-autocomplete
          class="flex-1"
          [label]="'Base currency'"
          [options]="currencies | filterCurrencies: exchangeRate.toCurrencyCode"
          [required]="true"
          [control]="getControl('fromCurrencyControl')"
          [optionFn]="optionFunction"
          [displayFn]="optionFunction"
          [disabled]="exchangeRate.id"
          (onSelectionChange)="exchangeRate.fromCurrencyCode = $event.event" />
        <scope-ui-autocomplete
          class="flex-1"
          [label]="'Convert to currency'"
          [options]="currencies | filterCurrencies: exchangeRate.fromCurrencyCode"
          [required]="true"
          [control]="getControl('toCurrencyControl')"
          [optionFn]="optionFunction"
          [displayFn]="optionFunction"
          [disabled]="exchangeRate.id"
          (onSelectionChange)="exchangeRate.toCurrencyCode = $event.event" />
      </div>
      <div class="flex flex-row gap-8 mt-2">
        <span class="flex-1 exchange-rate-hint"
          >1 unit of base currency converts to this amount of units in the selected currency</span
        >
        <scope-ui-input
          class="flex-1"
          [inputLabel]="'Exchange rate'"
          [decimalPlaces]="4"
          [separatorLimit]="'1000000000'"
          [required]="true"
          [control]="getControl('exchangeRateControl')"
          [parseNumber]="true"
          (onInputChange)="exchangeRate.exchangeRate = $event" />
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex-col">
  <div class="mt-8 flex w-full justify-end">
    <button
      mat-button
      mat-dialog-close>
      <span class="tracking-normal">Cancel</span>
    </button>
    <button
      mat-flat-button
      class="ml-8"
      *ngIf="!loading"
      (click)="confirm()"
      [disabled]="disableSubmit()">
      <span class="tracking-normal">Save</span>
    </button>
    <button
      mat-flat-button
      class="ml-8"
      *ngIf="loading">
      <img
        src="/assets/icons/loading.svg"
        alt="loading"
        class="icon-spinner" />
    </button>
  </div>
</mat-dialog-actions>
